type FormContainerProps = {
  title?: string;
  subTitle: string;
  children: React.ReactNode;
};

export function FormContainer({
  children,
  title,
  subTitle,
}: FormContainerProps) {
  return (
    <section>
      <div className="mb-2">
        {title && <h1 className="font-bold text-xl text-[#091B66]">{title}</h1>}
        <p className="py-1 text-[#434249]">{subTitle}</p>
      </div>

      {children}
    </section>
  );
}

export function FormSubSectionTitle({ title }: { title: string }) {
  return (
    <h2 className="text-lg font-semibold text-[#434249] py-2 my-2 border-y border-[#E4E4E4]">
      {title}
    </h2>
  );
}

export default FormContainer;
